jQuery(($) => {
  class Slider {
    constructor(element, args = {}) {
      this._ = element;
      this._element = $(element);
      this._list = this._element.find('.o-slider-carousel__list');
      this._prev = this._element.find('.o-slider-carousel__arrow.o-slider-carousel__arrow--prev');
      this._next = this._element.find('.o-slider-carousel__arrow.o-slider-carousel__arrow--next');
      this._currentIndex = this._element.find('.o-slider-carousel__pagination__current');
      this._progressBar = this._element.find('.o-slider-carousel__progress__fill');

      this._isSingleSlide = this._element.hasClass('o-slider-carousel--single-slide');

      this._args = $.extend(
        {
          slidesToShow: 1,
          arrows: true,
          prevArrow: this._prev,
          nextArrow: this._next,
          variableWidth: !this._isSingleSlide,
          centerMode: this._isSingleSlide,
          centerPadding: '0px',
        },
        args
      );

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this.setupSlick();
      this._element.trigger('init', this);
      this._element.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        this._currentIndex.text(nextSlide + 1);
        this._progressBar.css('width', ((nextSlide + 1) / slick.slideCount) * 100 + '%');
        if (nextSlide === 0 && currentSlide === slick.slideCount - 1) {
          this._element.addClass('o-slider-carousel--resetting');

          setTimeout(() => {
            this._element.removeClass('o-slider-carousel--resetting');
          }, 500);
        }

        // If slide has a video, stop it before sliding
        const currentSlideElement = slick.$slides.eq(currentSlide);
        if (currentSlideElement && currentSlideElement.find('.m-video').length) {
          const videoEl = currentSlideElement.find('.m-video')[0];
          videoEl?.video?.handleStop();
        }
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {}

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Slick
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupSlick = () => {
      this._list.slick(this._args);
      this._element.trigger('setup-slick', this);
    };
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.slider = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slider = new Slider(_[i], opt);
      else ret = _[i].slider[opt].apply(_[i].slider, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-slider-carousel').slider();
});
